<template>
  <div class="warp">
    <img class="top_bg top_bg2" src="@/assets/img/ancientBooks/bg.png" alt="" />
    <div class="layout_con page_w">
      <!-- content -->
      <myHeader></myHeader>
      <!-- 搜索 -->
      <div class="search_box">
        <input
          class="search_keyword"
          type="text"
          v-model="searchVal"
          placeholder="请输入古籍书名"
          @keyup.enter="toSearch"
        />
        <div class="search_btn flex" @click="toSearch">
          <button>
            <img src="@/assets/img/common/fangdajing.png" alt="" />
          </button>
        </div>
      </div>
      <!-- banner -->
      <div class="show_info">
        <div class="show_picture">
          <el-carousel trigger="click" :interval="4000">
            <el-carousel-item v-for="item in banners" :key="item.id">
              <a target="_blank" :href="item.url">
                <img :src="encodeURI(item.image)" alt="" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="show_count_box ">
          <div class="show_count flex">
            <div class="item_title">
              数据统计
            </div>
            <div class="item">
              古籍共
              <countTo
                class="item_count"
                :startVal="0"
                :endVal="bookTotal"
                :duration="3000"
              ></countTo>
              种
            </div>
            <div class="item">
              古籍共
              <countTo
                class="item_count"
                :startVal="0"
                :endVal="fascicleTotal"
                :duration="3000"
              ></countTo>
              册
            </div>
            <div class="item">
              古籍共
              <countTo
                class="item_count"
                :startVal="0"
                :endVal="4636"
                :duration="3000"
              ></countTo>
              页
            </div>
          </div>
        </div>
      </div>
      <!--hot  -->
      <div class="hot_card">
        <div class="card_tab_box">
          <div class="item_label"></div>
          <ul class="card_tab">
            <li
              class="item"
              :class="currentBook === index ? 'active' : ''"
              @click="bookChange(index, item.id)"
              v-for="(item, index) in bookClassify"
              :key="index"
            >
              {{ item.label }}
            </li>
          </ul>
          <router-link class="to_more" to="/digitalBooks"
            >更多 &gt;&gt;</router-link
          >
        </div>
        <ul v-if="bookList.length > 0" class="book_list">
          <li v-for="item in bookList" :key="item.id" :title="item.name">
            <router-link
              class="item"
              :to="`/digitalBooks/bookDetails/${item.id}`"
            >
              <div class="item_bg_box flex">
                <div class="item_bg">
                  <div class="item_img_box">
                    <img class="item_img" :src="encodeURI(item.image)" alt="" />
                  </div>
                </div>
              </div>
              <div class="item_info flex">
                <p>{{ item.name }}</p>
              </div>
            </router-link>
          </li>
        </ul>
        <div v-else class="no_data" style="margin-top:60px">
          <p>
            没有找到相关的内容
          </p>
        </div>
      </div>
      <!-- content end -->
    </div>
    <!-- 侧边导航 -->
    <sideTips></sideTips>
    <myFooter></myFooter>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import myFooter from '@/components/ancientFotter/index.vue'
import myHeader from '@/components/ancientHeader/index.vue'
import sideTips from '@/components/sideTips/index.vue'
import { getBookList } from '@/api/index'
export default {
  metaInfo: {
    title: '宝鸡典藏古籍数字平台'
  },
  components: {
    countTo,
    myFooter,
    myHeader,
    sideTips
  },
  data() {
    return {
      banners: [],
      searchVal: '', //搜索框内容
      bookClassify: [],
      currentBook: 0, //当前选中的下标
      bookList: [], //方志列表
      bookTotal: 0, //推荐古籍 总数
      fascicleTotal: 0 // 古籍分册 总数
    }
  },
  mounted() {
    this.getBanner()
    this.getClassify()
    this.getAllTotal()
  },
  methods: {
    // 跳转搜索
    toSearch() {
      if (this.searchVal.trim()) {
        this.$router.push({
          path: '/digitalBooks',
          query: {
            keyword: this.searchVal
          }
        })
      }
    },
    // 获取轮播图
    async getBanner() {
      let res = await this.$http.get('/api/carousel', {
        params: {
          sort: 'sort,asc',
          category: false
        }
      })
      this.banners = res.content
    },
    // 获取推荐古籍分类
    async getClassify() {
      const { content: bookClassify } = await this.$http.get('/api/navigation')
      this.bookClassify = bookClassify
      this.getBookData(this.bookClassify[0].id)
    },
    // 获取 推荐古籍 列表
    async getBookData(id) {
      let { content: bookList } = await getBookList({
        page: 0,
        size: 5,
        ancestors: id
      })
      this.bookList = bookList
    },
    // 推荐古籍选择
    bookChange(i, id) {
      // if (i === 1) {
      //   this.currentBook = i
      //   this.getBookData(id)
      // }
      this.currentBook = i
      this.getBookData(id)
    },
    // 古籍分册总数
    async getAllTotal() {
      let bookTotal = await getBookList()
      let fascicleTotal = await this.$http.get('/api/fascicle')
      this.bookTotal = bookTotal.totalElements
      this.fascicleTotal = fascicleTotal.totalElements
    }
  }
}
</script>

<style lang="less" scoped>
.search_box {
  width: 850px;
  height: 46px;
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 70px;
  .search_keyword {
    flex: 1;
    border: 0;
    background: #f7f4ed;
    padding: 0 10px;
    color: #9a856d;
    &::-webkit-input-placeholder {
      color: #9a856d;
      font-size: 14px;
      letter-spacing: 2px;
    }
  }
  .search_btn {
    width: 90px;
    background: @theme;
    cursor: pointer;
    button {
      border: 0;
      background: transparent;
      cursor: pointer;
    }
  }
}
.show_info {
  margin-top: 90px;
  display: flex;
  width: 100%;
  height: 400px;
  // justify-content: space-between;
  /deep/.el-carousel__container {
    height: 380px;
  }
  .show_picture {
    // width: 880px;
    width: 70%;
    height: 100%;
    padding: 10px;
    background: #fff;
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    // margin-right: 20px;
    margin-right: 2%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .show_count_box {
    // width: 296px;
    width: 28%;
    height: 100%;
    // padding: 10px;
    background-color: #fff;
  }
  .show_count {
    width: 100%;
    height: 100%;
    background: url('../../assets/img/ancientBooks/num_bg.jpg') no-repeat center;
    background-size: 100% 100%;
    flex-direction: column;
    position: relative;
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    padding-top: 70px;
    .item {
      font-size: 20px;
      letter-spacing: 2px;
      margin: 15px 0;
    }
    .item_count {
      font-size: 36px;
      color: #a61b29;
      margin: 0 4px;
    }
    .item_title {
      font-size: 20px;
      color: #fff;
      position: absolute;
      right: 20px;
      top: 40px;
      letter-spacing: 2px;
    }
  }
}
.hot_card {
  margin-top: 60px;
  .card_tab_box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ccbdb3;
    padding-bottom: 10px;
    margin-bottom: 30px;
    .item_label {
      font-size: 18px;
      color: #4e2f0d;
      margin-right: 40px;
    }
    .card_tab {
      display: flex;
      .item {
        font-size: 14px;
        color: #4e2f0d;
        padding: 5px 15px;
        cursor: pointer;
        // &:nth-child(1) {
        //   cursor: no-drop;
        // }
        // &:nth-child(3) {
        //   cursor: no-drop;
        // }
        // &:nth-child(4) {
        //   cursor: no-drop;
        // }
      }
      .active {
        background: @theme;
        border-radius: 12px;
        color: #fff;
      }
    }
    .to_more {
      font-size: 16px;
      color: #4e2f0d;
      margin-left: auto;
      &:hover {
        color: @theme;
      }
    }
  }
  .book_list {
    display: flex;
    li {
      width: 20%;
      padding-right: 25px;
      padding-bottom: 35px;
      border-radius: 4px 4px 0 0;
      overflow: hidden;
      &:nth-child(5n) {
        padding-right: 0;
      }
      &:hover {
        .item_img_box {
          transform: rotateY(20deg);
        }
        .item_img {
          transform: rotateY(20deg);
        }
        .item_info {
          background: rgba(230, 224, 208, 0.6);
        }
        a {
          box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
        }
      }
    }
    .item {
      display: block;
      .item_bg_box {
        width: 100%;
        height: 280px;
        background: url('../../assets/img/ancientBooks/book_bg.jpg');
      }
      .item_bg {
        width: 160px;
        height: 230px;
        background-color: #656566;
        border-radius: 5px;
      }
      .item_img_box {
        width: 100%;
        height: 100%;
        transition: all 0.6s;
        background-color: #fff;
        transform-origin: 100% 0;
        .item_img {
          width: 100%;
          height: 100%;
          transform-origin: 100% 0;
          transition: all 0.6s;
          border-radius: 5px;
        }
      }
    }
    .item_info {
      width: 100%;
      height: 60px;
      background: #fcfaf5;
      padding: 0 20px;
      flex-direction: column;
      transition: all 0.2s ease-out;
      p {
        width: 100%;
        margin: 6px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        &:nth-child(1) {
          color: #4e2f0d;
          font-size: 16px;
        }
        &:nth-child(2) {
          color: #9a856d;
          font-size: 14px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .show_info {
    height: 340px;
    /deep/.el-carousel__container {
      height: 320px;
    }
    .show_count {
      padding-top: 40px;
      .item_title {
        font-size: 16px;
        color: #fff;
        position: absolute;
        right: 14px;
        top: 32px;
        letter-spacing: 2px;
      }
      .item {
        font-size: 16px;
      }
      .item_count {
        font-size: 24px;
      }
    }
  }
  .book_list {
    flex-wrap: wrap;
    li {
      width: 25% !important;
      &:nth-child(4n) {
        padding-right: 0;
      }
      &:nth-child(5n) {
        padding-right: 25px !important;
      }
    }
  }
}
</style>
